import {
    Collapse,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Chip,
    Tooltip,
    IconButton,
} from '@mui/material';
import React, { ReactElement } from 'react';
import { formatNumber } from '../../common/Extensions';
import { DimensionTypeSR, GoodsStatusSR, DimensionTypeDimensionSR } from '../../common/Types';
import { GoodsTableArrivalInfo, getColorForGoodsStatus } from './GoodsHelper';
import { DimensionType } from '../../api/ClientApi';
import EditIcon from '@mui/icons-material/Edit';
import { useAppSelector } from '../../hooks/hooks';
import { canManipulateGoods, isEmployeeFinanceManager } from '../../redux/selectors/employeeSelector';

type GoodsTableCollapsibleArrivalInfoProps = {
    isCollapsed: boolean;
    isSiteTable: boolean;
    dimensionType?: DimensionType;
    goodsArrivalInfo?: GoodsTableArrivalInfo[];
    handleOpenBatchForm(batchId?: number): void;
};

export default function GoodsTableCollapsibleArrivalInfo(props: GoodsTableCollapsibleArrivalInfoProps): ReactElement {
    const { isCollapsed, isSiteTable, dimensionType, goodsArrivalInfo, handleOpenBatchForm } = props;

    const isFinanceManager = useAppSelector(isEmployeeFinanceManager);
    const canChangeGoods = useAppSelector(canManipulateGoods);

    const companyDetails = useAppSelector((state) => state.companyDetails.companyDetails);

    return (
        <Collapse in={!isCollapsed} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
                <Table size="small" aria-label="purchases">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID serije</TableCell>
                            <TableCell align="center">Dobavljač</TableCell>
                            <TableCell align="center">Ulazno vreme</TableCell>
                            <TableCell align="center">Br. fakture</TableCell>
                            <TableCell align="center">Status robe</TableCell>
                            {isFinanceManager && (
                                <TableCell align="center">
                                    Nabavna cena {companyDetails?.currency ? '(' + companyDetails.currency + ')' : ''}
                                </TableCell>
                            )}
                            <TableCell align="center">
                                {dimensionType ? DimensionTypeSR[dimensionType] : 'Količina'}
                            </TableCell>
                            {!isSiteTable && <TableCell align="center">Skladište</TableCell>}
                            {canChangeGoods && <TableCell align="center">Akcije</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {goodsArrivalInfo?.map((gi) => (
                            <TableRow key={(gi.batchId ? gi.batchId.toString() : '/') + Math.random()}>
                                <TableCell component="th" scope="row">
                                    {gi.batchId ?? '/'}
                                </TableCell>
                                <TableCell align="center">{gi.batchClient ?? '/'}</TableCell>
                                <TableCell align="center">
                                    {gi.batchArrivalTime ? gi.batchArrivalTime.toLocaleDateString('sr') : '/'}
                                </TableCell>
                                <TableCell align="center">{gi.batchUniqueId ?? '/'}</TableCell>
                                <TableCell align="center">
                                    {gi.isReserved ? (
                                        <Chip variant="outlined" label={'Rezervisano'} color="default" />
                                    ) : gi.batchStatus ? (
                                        <Chip
                                            variant="outlined"
                                            label={GoodsStatusSR[gi.batchStatus]}
                                            color={getColorForGoodsStatus(gi.batchStatus)}
                                        />
                                    ) : (
                                        '/'
                                    )}
                                </TableCell>
                                {isFinanceManager && (
                                    <TableCell align="center">
                                        {gi.batchPrice ? formatNumber(gi.batchPrice) : '/'}
                                    </TableCell>
                                )}
                                <TableCell align="center">
                                    {gi.goodsQuantity ? formatNumber(gi.goodsQuantity) : '/'}{' '}
                                    {dimensionType ? DimensionTypeDimensionSR[dimensionType] : 'kom.'}
                                </TableCell>
                                {!isSiteTable && <TableCell align="center">{gi.siteName ?? '/'}</TableCell>}
                                {canChangeGoods && (
                                    <TableCell align="center">
                                        <Tooltip title="Izmeni detalje" placement="top">
                                            <IconButton color="primary" onClick={() => handleOpenBatchForm(gi.batchId)}>
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Collapse>
    );
}
